import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as uuid from 'uuid';

@Component({
  selector: 'app-country-dropdown',
  templateUrl: './country-dropdown.component.html',
  styleUrls: ['./country-dropdown.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class CountryDropdownComponent implements OnInit, OnChanges  {
  @Input() countryCodes: any[];
  @Input() formCtrlName: any;
  @Input() formGrp: FormGroup;
  @Input() displayMode: 'code' | 'country' = 'code';
  selectedCode: any = '+44';
  selectedCodeDefault: any = 'GB';
  selectedCountryName: string = 'United Kingdom';
  id = 'dd-' + uuid.v4();
  dropdownEL: any;
 searchForm = new FormGroup({
    searchTerm: new FormControl('',),

  });
  originalCountries: any[] = [];
  displayedCountries: any[] = [];
  constructor() {

  }

  ngOnInit() {
    this.setFormValue();
     this.searchForm.controls.searchTerm.valueChanges
          .pipe(debounceTime(400), distinctUntilChanged())
          .subscribe((term) => {
            this.searchList(term as string);
          });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['countryCodes'] && this.countryCodes) {
      this.originalCountries = [...this.countryCodes];
      this.displayedCountries = [...this.countryCodes];
    }
  }


  getImage(code: any) {
    return code?.toLowerCase()
  }


  //  get countryCodes(): string[] {
  //   if (!this.searchTerm) return this.items;
  //   return this.items.filter(item =>
  //     item.toLowerCase().includes(this.searchTerm.toLowerCase())
  //   );
  // }


    searchList(event: any) {
      // console.log('searchList', event);

      if (!event) {
      this.displayedCountries = [...this.originalCountries];
    } else {
      this.displayedCountries = this.originalCountries.filter(item =>
        item.name?.toLowerCase().includes(event.toLowerCase())
      );
      // console.log('displayedCountries', this.displayedCountries);
    }
    }

  onSelectCode(code: any) {
    this.selectedCode = code.dial_code;
    this.selectedCodeDefault = code.code;
    this.selectedCountryName = code.name;
    this.setFormValue();
  }
  setFormValue() {
    if(this.formCtrlName && this.formGrp) {
      const value = this.displayMode === 'country' ? this.selectedCountryName : this.selectedCode;
      this.formGrp.get(this.formCtrlName)?.setValue(value);
    }
  }
}
